/** Stable ids and priority map for the onboarding hint display queue. */
import {
  ONBOARDING_HINT_BACKLOG_INTRO,
  ONBOARDING_HINT_CONTEXT_INTRO,
  ONBOARDING_HINT_FOCUS,
  ONBOARDING_HINT_INBOX_INTRO,
  ONBOARDING_HINT_NEXT_ACTION_PANEL,
  ONBOARDING_HINT_ORGANIZE_INTRO,
  ONBOARDING_HINT_TRIAGE,
} from '@/constants/onboardingHints';

export const ONBOARDING_HINT_QUEUE_IDS = {
  NEXT_ACTION_PANEL: ONBOARDING_HINT_NEXT_ACTION_PANEL,
  TRIAGE: ONBOARDING_HINT_TRIAGE,
  FOCUS: ONBOARDING_HINT_FOCUS,
  ORGANIZE_INTRO: ONBOARDING_HINT_ORGANIZE_INTRO,
  BACKLOG_INTRO: ONBOARDING_HINT_BACKLOG_INTRO,
  INBOX_INTRO: ONBOARDING_HINT_INBOX_INTRO,
  CONTEXT_INTRO: ONBOARDING_HINT_CONTEXT_INTRO,
};

/** Lower number = shown first. */
export const ONBOARDING_HINT_QUEUE_PRIORITIES = {
  [ONBOARDING_HINT_QUEUE_IDS.NEXT_ACTION_PANEL]: 10,
  [ONBOARDING_HINT_QUEUE_IDS.TRIAGE]: 20,
  [ONBOARDING_HINT_QUEUE_IDS.FOCUS]: 30,
  [ONBOARDING_HINT_QUEUE_IDS.ORGANIZE_INTRO]: 40,
  [ONBOARDING_HINT_QUEUE_IDS.BACKLOG_INTRO]: 50,
  [ONBOARDING_HINT_QUEUE_IDS.INBOX_INTRO]: 55,
  [ONBOARDING_HINT_QUEUE_IDS.CONTEXT_INTRO]: 60,
};
